import { apiEventAll } from '@common/helper';

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentCartStoreService, DeliveryInformationStoreService, GetCartStoreService } from '@common/services';
import { GetCartState } from '@common/store';
import { RoutesResRoutes } from '@conf/routes.config';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { PostGetCartRequest } from 'src/sdk-reservation';

@Component({
  selector: 'asw-pet-input-test',
  templateUrl: './pet-input-test.component.html',
  styleUrls: ['./pet-input-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PetInputTestComponent extends SupportComponent implements OnInit {
  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _currentCartStoreService: CurrentCartStoreService,
    private _getCartStoreService: GetCartStoreService
  ) {
    super(_common);
  }

  public moveToPetInput(): void {
    this._router.navigateByUrl(RoutesResRoutes.PET_RESERVATION_INFORMATION_REQUEST);
  }

  public process() {
    const getCartRequestParam: PostGetCartRequest = {
      cartId: 'test',
      refresh: false,
      mask: false,
    };
    apiEventAll(
      () => {
        this._getCartStoreService.setGetCartFromApi(getCartRequestParam);
      },
      this._getCartStoreService.getGetCart$(),
      (res: GetCartState) => {
        this._currentCartStoreService.setCurrentCart(res);
        console.log('操作中カート初期化完了');
      },
      () => {}
    );
  }
}
